"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.talkTimeTranslations = {
    "en": {
        average: "Average",
        maximum: "Maximum",
        talkTime: "Talk Time",
    },
    "de": {
        average: "Durchschnittlich",
        talkTime: "Gesprächszeit",
        maximum: "Maximal",
    },
    "nl": {
        average: "Gemiddeld",
        talkTime: "Gesprekstijd",
        maximum: "Maximaal",
    },
    "it": {
        average: "Medio",
        talkTime: "Tempo di conversazione",
        maximum: "Massimo",
    },
    "fr": {
        average: "Moyenne",
        talkTime: "Temps de parole",
        maximum: "Maximum",
    },
    "es": {
        average: "Promedio",
        talkTime: "Tiempo de conversación",
        maximum: "Máximo",
    },
    "ja": {
        average: "平均",
        talkTime: "対話時間",
        maximum: "最長",
    },
    "en-GB": {
        average: "Average",
        talkTime: "Talk Time",
        maximum: "Maximum",
    },
    "ru": {
        average: "Среднее",
        maximum: "Максимальное",
        talkTime: "Время Разговора",
    },
};
